export default __webpack_public_path__ + "static/media/black_and_white_flower.c878ec7a.jpg";